export default __webpack_public_path__ + "static/media/announce-home-sharing.6b325fff.png";